// extracted by mini-css-extract-plugin
export var main = "_5-1";
export var shell = "_5-0";